<template>
  <div class="sale">
    <el-tabs v-model="activeName">
      <el-tab-pane label="团队介绍" name="1">
        <Introduction v-if="activeName=='1'"></Introduction>
      </el-tab-pane>
      <el-tab-pane label="销量排名" name="2">
        <SaleRank v-if="activeName=='2'"></SaleRank>
      </el-tab-pane>
      <el-tab-pane label="销售提示" name="3">
        <SalePrompt v-if="activeName=='3'"></SalePrompt>
      </el-tab-pane>
      <el-tab-pane label="销售网络" name="4">
        <SaleInternet v-if="activeName=='4'"></SaleInternet>
      </el-tab-pane>
      <el-tab-pane label="业绩趋势" name="5">
        <SaleTrend v-if="activeName=='5'"></SaleTrend>
      </el-tab-pane>
      <el-tab-pane label="区域对比" name="6">
        <SaleAreaDB v-if="activeName=='6'"></SaleAreaDB>
      </el-tab-pane>
      <el-tab-pane label="销售明星" name="7">
        <SaleStar v-if="activeName=='7'"></SaleStar>
      </el-tab-pane>
      <el-tab-pane label="团队风采" name="8">
        <TeamStyle v-if="activeName=='8'"></TeamStyle>
      </el-tab-pane>
      <el-tab-pane label="重点客户" name="9">
        <ImportantClient v-if="activeName=='9'"></ImportantClient>
      </el-tab-pane>
      <el-tab-pane label="渠道分布" name="10">
        <Channel v-if="activeName=='10'"></Channel>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Introduction from './teamIntroduction'
import SaleRank from './saleRank'
import SalePrompt from './salePrompt'
import SaleInternet from './saleInternet'
import SaleTrend from './saleTrend'
import SaleAreaDB from './saleAreaDB'
import SaleStar from './saleStar'
import TeamStyle from './teamStyle'
import ImportantClient from './importantClient'
import Channel from './channel'
export default {
  components: {
    Introduction,
    SaleRank,
    SalePrompt,
    SaleInternet,
    SaleTrend,
    SaleAreaDB,
    SaleStar,
    TeamStyle,ImportantClient,Channel
  },
  data() {
    return {
      activeName: '1',
    }
  },
  mounted() {},
  methods: {
    // handleClick(tab, event) {
    //   console.log(tab, event);
    // }
  },
}
</script>

<style lang="less">
.sale { height: 100%; overflow: hidden;
  .trend-title{ display: inline-block; width: 6rem; text-align: right; height: 1.8rem; padding:0 .8rem; line-height: 1.8rem; font-size: .8rem; background: #3570ff;}
  .last-save{ text-align: left; margin-bottom: 1rem; margin-top: 2rem;}
}
</style>